module.exports = __webpack_public_path__ + "img/p15.6fce0628.png";